module.exports = __webpack_public_path__ + "img/img_applicable_03.7e6a901d.png";